<template>
  <SearchableModel
    model-name="AuthenticationLog"
    :base-filters="baseFilters"
    :available-filters="availableFilters"
    :push-state="pushState"
    :search-placeholder="searchPlaceholder ?? $t('Search by user or IP address')"
    :class="className"
  >
    <template #header-title>
      <slot name="header-title" />
    </template>
    <template #header-actions>
      <slot name="header-actions" />
    </template>
    <template #default="{ models }">
      <AuthenticationLogIndexTable v-if="models" :logs="models" :show-user="showUser" />
    </template>
  </SearchableModel>
</template>

<script setup>
import AuthenticationLogIndexTable from './AuthenticationLogIndexTable.vue'
import SearchableModel from '@/components/searchable-model/SearchableModel.vue'

defineProps({
  baseFilters: {
    type: Object,
    default: () => ({}),
  },
  availableFilters: {
    type: Array,
    default: () => [],
  },
  showUser: {
    type: Boolean,
    default: true,
  },
  searchPlaceholder: {
    type: String,
    default: null,
  },
  pushState: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: null,
  },
})
</script>
